import { navigate } from 'navigation/methods';

const getDoNavigate = (spaceId: number, text?: string | null) => {
  return () => navigate('Search', { spaceId, text });
};

export default getDoNavigate;
